import { combineReducers } from "redux";
import SidePanReducer from "./SidePanReducer";
import MMPLDashboardReducer from "./MMPLDashboardReducer";
import ShipViewReducer from "./ShipViewReducer";
import POViewReducer from "./POViewReducer";
import ClientDashboardReducer from "./ClientDashboardReducer";
import PageLoaderReducer from "./PageLoaderReducer";
import MasterScreenReducer from "./MasterScreenReducer";
import UserManageReducer from "./UserManageReducer";
import SpecialAccessReducer from "./SpecialAccessReducer";

const rootReducer = combineReducers({
  SidePanReducer,
  MMPLDashboardReducer,
  ShipViewReducer,
  ClientDashboardReducer,
  POViewReducer,
  PageLoaderReducer,
  MasterScreenReducer,
  UserManageReducer,
  SpecialAccessReducer,
});
export default rootReducer;
